
import Vue from 'vue';
import i18n from '@/i18n';
import { isMobileDevice } from '@/helpers/mobile';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import KalturaPlayer from '@/components/KalturaPlayer.vue';

interface ISlide {
  video: {
    providerId: string;
  };
  content: string;
}

interface IArticle {
  title: string;
  slides: Array<ISlide>;
}

export default Vue.extend({
  i18n,
  components: {
    Swiper,
    SwiperSlide,
    KalturaPlayer,
  },
  data(): any {
    return {
      article: this.$t('helpCenter.firstSteps'),
      selectedSlide: 1,
    };
  },
  mounted() {
    this.article = this.mapSlides();
  },
  methods: {
    mapSlides(): IArticle {
      const { desktopSlides, mobileSlides, title } = this.article;

      return {
        title,
        slides: this.isMobileDevice() ? mobileSlides : desktopSlides,
      };
    },
    onSlideChange(slider: { activeIndex: number }): void {
      this.selectedSlide = slider.activeIndex + 1;
    },
    sliderOptions() {
      return {
        initialSlide: this.selectedSlide - 1,
        spaceBetween: 10,
        autoHeight: true,
        navigation: {
          nextEl: '.help-center .next',
          prevEl: '.help-center .prev',
        },
      };
    },
    isMobileDevice(): boolean {
      return isMobileDevice();
    },
  },
});
